















import {Vue, Component} from 'vue-property-decorator';

@Component
export default class ToolTip extends Vue {

  public isOpen: boolean = false;
  public tipPosition: any = {
    "top": '16px',
    "left": '16px',
    "right": '16px',
  };
  public arrowPosition: any = {
    "top": '-5px',
    "bottom": 'unset',
    "left": 'calc(50% - 5px)', // Dans l'idéal il faudrait utilsier pythagore, mais on est pas au pixel près
  };

  public get element(): HTMLElement {
    return this.$refs.TooltipButton as HTMLElement;
  }

  public get message(): HTMLElement {
    return this.$refs.toolTipMessage as HTMLElement;
  }

  public updateTip = () => {
    this.updateTipPosition();
  };

  mounted() {
    window.addEventListener('resize', this.updateTip);
  }

  destroyed() {
    window.removeEventListener('resize', this.updateTip);
  }

  public toggleToolTip() {
    this.isOpen ? this.hideToolTip() : this.showToolTip();
  }

  public showToolTip() {
    this.updateTipPosition();
    this.isOpen = true;
  }

  public hideToolTip() {
    this.isOpen = false;
  }

  public updateTipPosition() {
    const position = this.element.getBoundingClientRect();
    const buttonWidth = this.element.offsetWidth;
    const positionApp = document.querySelector('#app')!.getBoundingClientRect();

    // Dans l'idéal, il faudrait encore gérer les margins, pour le moment, ça fonctionne quand l'élement n'a pas de margins
    if (position.top <= window.innerHeight - position.top) { // ToolTip en bas
      this.tipPosition = {
        "top": 'calc(' + position.bottom + 'px + 5px)',
      };
      this.arrowPosition = {
        "top": '-5px',
        "bottom": 'unset',
        "left": 'calc(' + ((position.left - positionApp.left) + (buttonWidth / 2)) + 'px - (5px + 16px))', // les 16px, correspondent au padding
      };
    } else { // ToolTip en haut
      this.tipPosition = {
        "top": 'calc(' + (position.top) + 'px - 10px)',
        "transform": 'translateY(-100%)',
      };
      this.arrowPosition = {
        "top": 'unset',
        "bottom": '-5px',
        "left": 'calc(' + (position.left + (buttonWidth / 2)) + 'px - (5px + 16px))', // les 16px, correspondent au padding
      };
    }
  }

}

